// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
/**
 * HomeLayout - gebruik alleen voor /home (welkomstpagina).
 * Geen sidebar, geen BottomTabBar.
 * Rustig, gefocust - gebruiker kiest bewust de eerste stap.
 */
import { Outlet }        from 'react-router-dom'
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import { cn }            from '@/lib/utils'

export function HomeLayout() {
  const { isMobile } = useBreakpoint()

  return (
    <div className="flex h-screen w-full flex-col overflow-hidden bg-sand">
      {/* Minimal top bar - geen menu-knop, geen navigatie */}
      <header className="flex h-14 w-full flex-shrink-0 items-center border-b border-sand-300 bg-white/80 backdrop-blur-sm px-5">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-moss">
            <span className="text-xs font-bold text-white">W</span>
          </div>
          <span className="text-sm font-semibold text-ink">WilsApp</span>
        </div>
      </header>

      {/* Scrollable content - gecentreerd, maximale breedte voor leesbaarheid */}
      <main className="flex-1 overflow-y-auto">
        <div
          className={cn(
            'mx-auto w-full',
            isMobile ? 'px-4 py-6 max-w-lg' : 'px-6 py-8 max-w-lg',
          )}
        >
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
    </div>
  )
}
